import EditClientInfo from './EditClientInfo.vue';

export default EditClientInfo;
